import { usePost } from '../../HttpClient';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';
import { ConfigRule } from '@app/models';
import { tenantHierarchyBaseUrl } from '../BaseUrls';

export function useAddConfig() {
  const post = usePost(true, "tms");
  return useMutationWithErrorHandling({
    mutationFn: async ({
      organisationUnitId,
      categoryId,
      request,
    }: {
      organisationUnitId: string;
      categoryId: string;
      request: ConfigRule[];
    }) => {
      return await post(
        `${tenantHierarchyBaseUrl}/organisation-units/${organisationUnitId}/category/${categoryId}/rules`,
        request
      );
    },
  });
}
